var _style, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g2, _path31, _path32, _path33, _path34, _g3, _path35, _g4, _path36, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStep2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 65 51",
    style: {
      enableBackground: "new 0 0 65 51"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010B40;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#828383;}\n\t.st3{fill:#606060;}\n\t.st4{fill:#E5E3E1;}\n\t.st5{fill:#6C63FF;}\n\t.st6{opacity:0.4;fill:#A9A19C;enable-background:new    ;}\n\t.st7{opacity:0.5;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st8{fill:#F9F9F9;}\n\t.st9{fill:#FDB927;}\n\t.st10{opacity:0.5;fill:#FDB927;enable-background:new    ;}\n\t.st11{opacity:0.3;fill:#FDB927;enable-background:new    ;}\n\t.st12{opacity:0.5;fill:url(#SVGID_00000168800128204303186080000003979465144536213659_);enable-background:new    ;}\n\t.st13{fill:#EB335B;}\n\t.st14{opacity:0.5;fill:#EB335B;enable-background:new    ;}\n\t.st15{opacity:0.3;fill:#EB335B;enable-background:new    ;}\n\t.st16{opacity:0.5;fill:url(#SVGID_00000021118330889770014030000007821471422640240031_);enable-background:new    ;}\n\t.st17{fill:#00AEB3;}\n\t.st18{opacity:0.5;fill:#00AEB3;enable-background:new    ;}\n\t.st19{opacity:0.3;fill:#00AEB3;enable-background:new    ;}\n\t.st20{opacity:0.5;fill:url(#SVGID_00000140711218317433031420000006826556487221106820_);enable-background:new    ;}\n\t.st21{opacity:0.5;fill:#162B4C;enable-background:new    ;}\n\t.st22{opacity:0.3;fill:#162B4C;enable-background:new    ;}\n\t.st23{display:none;}\n\t.st24{display:inline;fill:#FFB9B9;}\n\t.st25{display:inline;fill:#2F2E41;}\n\t.st26{display:inline;fill:#162B4C;}\n\t.st27{display:inline;fill:#CCCCCC;}\n\t.st28{fill:url(#SVGID_00000067209055144878356550000006177192354284022941_);}\n\t.st29{fill:url(#SVGID_00000012445956492414288090000002028527460511929762_);}\n\t.st30{fill:url(#SVGID_00000144317512736546344040000004484616067627281316_);}\n\t.st31{fill:url(#SVGID_00000063635367000612485880000003783883147503547271_);}\n\t.st32{fill:#010C3A;}\n\t.st33{fill:url(#SVGID_00000084514418421085051930000002311892379483596968_);}\n\t.st34{fill:url(#SVGID_00000140735337253766855750000006803482920208037281_);}\n\t.st35{fill:url(#SVGID_00000181780594016428748410000010562459755794561721_);}\n\t.st36{fill:url(#SVGID_00000011736843652849320950000004682480459725018558_);}\n\t.st37{fill:url(#SVGID_00000125562132458172345810000015640892445462976157_);}\n\t.st38{opacity:0.6;fill:#FFFFFF;enable-background:new    ;}\n\t.st39{opacity:0.72;fill:#FFFFFF;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.8,6.7L6.4,9.2c-0.5,0.1-0.8,0.6-0.7,1l3.9,16.9c0.1,0.5,0.6,0.7,1,0.6l11.4-2.5c0.5-0.1,0.8-0.6,0.7-1 L18.8,7.4C18.7,6.9,18.3,6.6,17.8,6.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6.8,12.3c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4C6.5,12.1,6.6,12.3,6.8,12.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.2,13.7c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4C6.8,13.5,7,13.7,7.2,13.7z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.8,23.8c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4C9.4,23.6,9.5,23.8,9.8,23.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M10.1,25.2c0.2,0,0.4-0.2,0.4-0.4c0-0.2-0.2-0.4-0.4-0.4c-0.2,0-0.4,0.2-0.4,0.4C9.8,25,9.9,25.2,10.1,25.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17.8,13.8l-7.9,1.7l0.3,1.3L18,15L17.8,13.8z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.6,18l19.8-7.2l9.2,23.6l-19.8,7.2L15.6,18z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M24.2,43l-9.9-25.5L36,9.5L45.9,35L24.2,43z M16.9,18.6l8.5,21.8l17.9-6.6l-8.5-21.8L16.9,18.6z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M35.6,31.5L25.9,35l0.2,0.4l9.7-3.6L35.6,31.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M42.7,31.5l-15.9,5.8l0.2,0.4l15.9-5.8L42.7,31.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M41.8,29.2l-4.1,1.5l0.2,0.4l4.1-1.5L41.8,29.2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M30.4,34.7l-4.1,1.5l0.2,0.4l4.1-1.5L30.4,34.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M36.4,32.5L32.3,34l0.2,0.4l4.1-1.5L36.4,32.5z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M42.3,30.3l-4.1,1.5l0.2,0.4l4.1-1.5L42.3,30.3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.5,17.5l-12,4.4l1.7,4.3l12-4.4L33.5,17.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.9961,
    y1: 17.5782,
    x2: 40.1193,
    y2: 30.4017,
    gradientTransform: "matrix(1 0 0 -1 0 51.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M38.1,21.5L38,34.3l4,0l0.1-12.8L38.1,21.5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M42.1,21.6l-3.8,0l-0.1,12.7l3.8,0L42.1,21.6z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M41.5,21.8l-2.7,0l0,2.6l2.7,0L41.5,21.8z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M41.5,25l-2.7,0l0,2.6l2.7,0L41.5,25z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M41.4,28.2l-2.7,0l0,2.6l2.7,0L41.4,28.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155142048759562051070000008657794146627696793_",
    gradientUnits: "userSpaceOnUse",
    x1: 2995.3533,
    y1: -9460.6992,
    x2: 2220.4932,
    y2: -6975.9082,
    gradientTransform: "matrix(1 0 0 -1 0 51.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000155142048759562051070000008657794146627696793_)",
      enableBackground: "new"
    },
    d: " M37.9,22.2L34,23.4l4,12.2l3.8-1.2L37.9,22.2z"
  }), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M37.8,22.3l-3.7,1.1l4,12l3.7-1.1L37.8,22.3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M37.4,22.7l-2.6,0.8l0.8,2.5l2.6-0.8L37.4,22.7z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M38.4,25.7l-2.6,0.8l0.8,2.5l2.6-0.8L38.4,25.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M39.4,28.7l-2.6,0.8l0.8,2.5l2.6-0.8L39.4,28.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000095297333411471648040000003030983953745508269_",
    gradientUnits: "userSpaceOnUse",
    x1: 4934.8799,
    y1: -8889.9189,
    x2: 3676.1096,
    y2: -6599.479,
    gradientTransform: "matrix(1 0 0 -1 0 51.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000095297333411471648040000003030983953745508269_)",
      enableBackground: "new"
    },
    d: " M35.5,23.1L32,25l6.5,11.1l3.5-1.9L35.5,23.1z"
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M35.5,23.2L32.1,25l6.4,11l3.3-1.8L35.5,23.2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M35.1,23.6l-2.4,1.3l1.3,2.3l2.4-1.3L35.1,23.6z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M36.7,26.4l-2.4,1.3l1.3,2.3l2.4-1.3L36.7,26.4z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M38.3,29.2l-2.4,1.3l1.3,2.3l2.4-1.3L38.3,29.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010301804542804216120000003346603312691724949_",
    gradientUnits: "userSpaceOnUse",
    x1: 6158.897,
    y1: -8432.8486,
    x2: 4621.0669,
    y2: -6309.3086,
    gradientTransform: "matrix(1 0 0 -1 0 51.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5351,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.12
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#808080",
      stopOpacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000010301804542804216120000003346603312691724949_)",
      enableBackground: "new"
    },
    d: " M34.1,24l-3.2,2.3l7.8,10.2l3.2-2.3L34.1,24z"
  }), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M34.1,24.2L31,26.4l7.7,10.1l3.1-2.2L34.1,24.2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.7,24.6l-2.2,1.6l1.6,2.1l2.2-1.6L33.7,24.6z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M35.7,27.2l-2.2,1.6l1.6,2.1l2.2-1.6L35.7,27.2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M37.6,29.7l-2.2,1.6l1.6,2.1l2.2-1.6L37.6,29.7z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M42.6,45.7l0.2,2.1L41.1,48l0.4-2.5L42.6,45.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M48.2,26.6L48.2,26.6c-1.4,0.4-2.1,1.9-1.6,3.4l0.6,1.9l0.6-0.2l0.1-0.8l0.1,0.7l3.8-1.1l0.1-0.7l0.1,0.7 l0.4-0.1L52,28.8C51.5,27.1,49.7,26.1,48.2,26.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M50.3,32.2c0.1,0,0.3,0,0.4,0c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.1,0.1,0.2,0.1,0.3 c0,0.3-0.1,0.7-0.6,1c-1.1,0.6-3.5,1.9-3.5,1.9l-4.6,0.9c0,0-2.3,1.8-2.6,0.8c-0.3-1,2.2-1.6,2.2-1.6l4.2-1l2.7-1.9 C49.1,33,49.6,32.3,50.3,32.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M51.8,36.4l-0.5,1.3L48.5,37l0.7-0.9L51.8,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M59.1,48.3l2.1-0.2l-1.5-1.4l-1,0.7L59.1,48.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M48.7,30.8c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7c0.9,0,1.7,0.7,1.7,1.7 C50.4,30.1,49.6,30.8,48.7,30.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M50,29.4c0,0,1,1.1,1.5,1.3c0.5,0.2,1.8,1.7,1.1,2.7c-0.6,1-2.9-0.2-2.9-0.2l0.1-1c0,0-1-1.6-1.2-1.8 C48.4,30.3,50,29.4,50,29.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M50.2,31.4c0.6-0.9,2.1-0.8,2.5,0.3c0,0,0,0,0,0.1c0.3,1.1-0.2,3-0.2,3l-0.8,2.2c0,0-2-0.9-3.4,0.6l0.2-1.5 c0,0-0.6-1.3,0.2-2.2C49.2,33.1,49.7,32.1,50.2,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M48.3,37.6c0,0,1-1.3,3.1-0.5l0.4,1c0,0,2.2,1.7,1,4.2l0.1,3.8l0.3,1.1l6.1-0.5l0.2,1.9l-1.1,0.1 c0,0-6.1,2.4-7.1,0.9c-1-1.5-3-7.2-3-7.2l-5.2,0.8c0,0,0.2,1.6,0,1.8c-0.2,0.2-0.1,1.1-0.2,1.2c-0.1,0.2,0,0.6,0,0.6l-1.7-0.1v-0.8 c0,0-0.2-1.1-0.2-1.4c0-0.3-1.3-4,0.9-4.4c2.2-0.3,5.9-0.9,5.9-0.9L48.3,37.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M60.1,48l0.1,0.6c0,0,2.8-0.5,3.3,0c0.6,0.5,0.6,0.8,1,0.5c0.2-0.1,0-0.5-0.2-0.8c-0.4-0.5-0.9-1-1.6-1.3 c-0.7-0.3-1.6-0.8-1.6-0.9c0-0.2-0.8-0.8-1-0.5c-0.3,0.3-0.8,1.2-0.8,1.2L60.1,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M42.8,46.8c0,0,0.6,2.1,0.4,2.2c-0.2,0.1-0.7,0.4-1.3,0.4c-0.4,0-1,0.2-1.4,0.4c-0.5,0.2-1,0.3-1.5,0.3 c-0.4,0-0.6-0.1-0.6-0.3c0.1-0.5,1.1-0.6,1.1-0.6l1.1-1.4c0,0,0.2-0.9,0.4-0.9c0.1,0,0.2,0,0.3-0.1H42.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M50.3,31.3c0.1-0.1,0.1-0.2,0.2-0.3c0.1-0.1,0.2-0.2,0.4-0.2c0.1,0,0.3-0.1,0.4-0.1c0.1,0,0.3,0,0.4,0.1 c0.3,0.2,0.7,0.5,0.6,1.2c0,1.4-0.1,4.5-0.1,4.5l-1.8,4.9c0,0,0.5,3.3-0.8,3c-1.2-0.3-0.4-3.1-0.4-3.1l1.4-4.7l-0.3-3.7 C50.4,32.8,50,32,50.3,31.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M49.1,27.1c-0.2-0.1-0.4-0.2-0.6-0.2c-0.2,0-0.4,0-0.6,0l0,0c-0.9,0.3-1.4,1.3-1.1,2.4l0,0l0.3-0.1L47,28.8 l0.2,0.4l1.9-0.6l0.1-0.4l0.1,0.3l0.4-0.1c0.4,0.8,0.4,1.7,0,2.7l0.6-0.2l0.1-0.7l0.1,0.7l1.2-0.4L51.4,29 C51.1,27.9,50.1,27.2,49.1,27.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103961044712109587780000006575451343164367033_",
    gradientUnits: "userSpaceOnUse",
    x1: 40.8389,
    y1: 16.8426,
    x2: 42.5897,
    y2: 16.8426
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103961044712109587780000006575451343164367033_)"
    },
    d: "M42.6,17.3c-0.1-0.6,0-1-0.1-1.1 c-0.2-0.1-0.1,0.5-0.2,0.6c-0.1,0-0.5-1.1-0.7-1c-0.1,0,0.2,0.8,0.2,0.8c0,0-0.5-0.8-0.6-0.8c-0.1,0.1,0.5,0.9,0.4,0.9 c-0.1,0-0.7-0.8-0.7-0.7c-0.1,0.1,0.5,0.8,0.5,0.8c0,0.1-0.5-0.5-0.5-0.4c-0.1,0.1,0.9,1,1.4,1.2C42.6,18,42.6,17.6,42.6,17.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026884765213654405160000001899237860085143739_",
    gradientUnits: "userSpaceOnUse",
    x1: 41.9779,
    y1: 21.0802,
    x2: 50.0384,
    y2: 21.0802
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026884765213654405160000001899237860085143739_)"
    },
    d: "M42,17.7c0.5,1,1.6,4.7,2.2,5.1 c0.7,0.5,5.1,2.4,5.7,1.7c0.5-0.7-0.1-3.3-0.1-3.3c-1.9,0.9-4.3,0.3-4.6,0c-0.3-0.2-1.9-2.6-2.5-3.7L42,17.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024713073094156427620000000393889791196912285_",
    gradientUnits: "userSpaceOnUse",
    x1: -7623.3438,
    y1: 1.1036,
    x2: -7616.874,
    y2: 17.7589,
    gradientTransform: "matrix(-0.8969 0.4422 -0.4422 -0.8969 -6774.481 3420.6804)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000024713073094156427620000000393889791196912285_)"
    },
    d: "M51.1,36.9l2.6-0.6l2.1,5.9 c0.1,0.4,0.3,0.6,0.7,0.8c0.5,0.2,1.1,1,1.6,1.6c0.9,1,1.5,2.1,1.5,2.1l0.7,0.1l0.2,0.3l-0.6,3l-0.6-1.8c-0.1-0.3-0.4-0.8-0.4-0.8 c-1.5-1.4-3.6-1.9-4.7-2.6c-0.4-0.3-0.8-0.7-0.9-1.2L51.1,36.9z"
  }), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.9,50.4l0.6-0.6c0.1-0.1,0.1-0.3,0.1-0.4c-0.1-0.4-0.2-1.2-0.1-1.5c0.2-0.3,1.1,0.6,1.1,0.6l0.1-0.1 l-1-1.2c-0.3-0.3-0.7-0.4-1-0.2l0,0c0,0,0.4,0.4,0.3,0.9c-0.1,0.5-0.2,2.1-0.2,2.1s-0.1,0.1-0.2,0.3 C59.4,50.4,59.8,50.6,59.9,50.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121973036463728627420000011334820562759951530_",
    gradientUnits: "userSpaceOnUse",
    x1: -7616.1709,
    y1: -40.5345,
    x2: -7599.2822,
    y2: 156.8509,
    gradientTransform: "matrix(-1 0 0 -1 -7564.3174 51.8898)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121973036463728627420000011334820562759951530_)"
    },
    d: "M48.1,47.8 C48.1,47.8,48.2,47.8,48.1,47.8c-0.1-1.7-3.3-3.7-3.9-6.5c-0.7-3.1,3.9-6.4,3.9-6.4l2.4,2.4L46.6,41c1.2,1.8,2.4,6.9,2.5,6.9v0 l0.5,0.6l0,0.3l-2.7,1.6l1.1-1.8C48,48.4,48.1,48.1,48.1,47.8z"
  }), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.5,50.7h0.9c0.2,0,0.3-0.1,0.4-0.2c0.3-0.3,0.8-1.1,1.1-1.1c0.4,0,0.3,1.3,0.3,1.3h0.2l0.3-1.6 c0.1-0.4-0.2-0.8-0.5-1l0,0c0,0-0.1,0.6-0.5,0.9c-0.5,0.3-1.8,1.2-1.8,1.2s-0.2,0-0.3,0C46.2,50.3,46.3,50.7,46.5,50.7z"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.2,21.3c-0.7,0.1-1.6,0.3-1.8,0.2c-0.2-0.1-0.3-0.1-0.3-0.1s-0.6,2.2-0.5,2.2c0.1,0.1,1.5,0.7,1.5,0.7 L48.2,21.3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M48.4,31.8c0,0-1.1,1.5-1.4,2.1c-0.7,1.2-1.6,2.5-2.4,4.2c0.7,1.1,2,1.6,3.3,2c2.3-2,5.9-5.7,6.3-6.6 C54.6,32.1,48.4,31.8,48.4,31.8z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M52.7,31.6c-0.3-0.8,0.8-0.9,0.4-1.8c-0.8-2.2-1.5-6.7-2.6-8.1c-1-1.4-2.6-0.5-3.3,0.7 c-0.7,1.2,0.1,8.7,0.4,8.8c0.5,0.3,0.9,0.9,1.1,1.3C50.3,32.8,51.4,32.5,52.7,31.6z"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.1,39.8c0.2-3.1-0.6-5.6-1-6.4c-0.4-1-1.1-1.6-1.3-2.1c-1.4,0.8-2.9,0.8-4.4,0.3c0.2,0.8,0.3,2,0.4,2.4 c0.5,1.2,0.5,2,1,3c0.7,1.2,1.5,2.8,2.1,4C53.4,40.9,54.2,40.6,55.1,39.8z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.1,31.5c-0.2,0-0.2,0.6,0,0.7c0.2,0.1,1.5,0.4,2.8,0.1c1.2-0.2,2.1-0.8,2.1-0.9c0-0.1-0.1-0.5-0.3-0.5 c-0.2,0.1-1.3,0.6-2.2,0.7C49.6,31.7,48.1,31.5,48.1,31.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114793018700171219770000009599285987089104267_",
    gradientUnits: "userSpaceOnUse",
    x1: 39.9747,
    y1: 24.8989,
    x2: 50.9548,
    y2: 24.8989
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114793018700171219770000009599285987089104267_)"
    },
    d: "M44.7,27.7c1.5,0,4-1.2,5.7-2.8 c0.7-0.7,0.7-1.8,0.1-2.5c-0.5-0.5-1.3-0.5-1.7,0l-1.2,1.4c0,0-1.1,1.6-3.1,2.2c-2,0.6-4.4,0.3-4.4,0.3L40,27 C40,27,42.7,27.8,44.7,27.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096027580034579682030000001870103748607089831_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.0002,
    y1: 26.3248,
    x2: 40.3267,
    y2: 26.3248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096027580034579682030000001870103748607089831_)"
    },
    d: "M40,26.4c-0.5-0.4-0.6-0.8-0.8-0.7 c-0.2,0.1,0.3,0.5,0.2,0.6c0,0.1-1.1-0.5-1.1-0.4c-0.1,0.1,0.7,0.5,0.7,0.5c0,0-0.9-0.3-1-0.2c0,0.1,0.9,0.4,0.9,0.5 c0,0.1-1-0.1-1,0c0,0.1,0.9,0.3,0.9,0.3c0.1,0-0.6-0.1-0.6,0c0,0.1,1.4,0.2,1.8,0.1C40.5,26.8,40.3,26.5,40,26.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035513272501876634760000016187119180905689216_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.8612,
    y1: 21.4926,
    x2: 50.1529,
    y2: 19.2553
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035513272501876634760000016187119180905689216_)"
    },
    d: "M48.7,21.2c-0.1,0.2,0.4,0.4,0.6,0.4 c0.2,0,0.6-0.4,0.7-0.4c0.3-0.6,0.1-2.2-0.4-2.2c-0.1,0-0.2,0-0.3,0.2C48.9,19.6,49,20.8,48.7,21.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00#000080206623771891702020000016423229322588729021_",
    gradientUnits: "userSpaceOnUse",
    x1: 48.1004,
    y1: 17.2247,
    x2: 51.0466,
    y2: 19.6968
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00#000080206623771891702020000016423229322588729021_)"
    },
    d: "M48,20.4c1.1,0.6,3.6-0.4,3.9-2 c0.2-1.6-1.5-3-3.1-1.8C47.2,17.8,47.2,19.9,48,20.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143618357497076777860000012027082384367648666_",
    gradientUnits: "userSpaceOnUse",
    x1: 47.7023,
    y1: 18.3519,
    x2: 48.7303,
    y2: 18.3519
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143618357497076777860000012027082384367648666_)"
    },
    d: "M48.7,17.7c-0.4,0.2-1.1,0.9-1,1.1 c0.1,0.2,0.4,0.2,0.4,0.2S48.9,17.6,48.7,17.7z"
  }))), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50.4,22.1c-0.5-0.2-1.3-0.5-2.5,1c-0.8,1-1.2,1.3-1.4,1.5c-0.1,0.1-0.1,0.2,0,0.2l1.3,1.9 c0.1,0.1,0.2,0.1,0.2,0.1c0.6-0.3,2.8-1.7,3.1-3C51.4,22.8,50.6,22.2,50.4,22.1z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53,19.1c-0.4,1.7,0.9,1.7,1.3,2.8c0.7,1.7,2.9,1.3,4.1,3.1c0.9,1.3,0.6,3.5-0.7,4.8c-1.8,1.8-4.9,1.5-6,0.2 c-1.1-1.2,0-3.1-1.5-4.6c-0.6-0.7-1.1-0.6-1.4-1.3c-0.5-1.2,0.5-2.6,0.8-3.2c0.8-1.2,1.3-1.3,1.4-1.9c0.1-1.1-1.1-1.4-2-1.9 c-0.4-0.2-0.4-0.8,0-1c0.9-0.5,2.6-1.3,3.8-0.2C54,17,53.2,18.4,53,19.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M57.3,29.1C57.3,29.1,57.3,29.1,57.3,29.1c0.8-1,1.1-1.9,0.9-2.8c-0.3-1.5-1.8-2.3-1.9-2.3c0,0-0.1,0-0.1,0 c0,0,0,0.1,0,0.1c0,0,1.5,0.8,1.8,2.2C58.2,27.2,58,28.1,57.3,29.1C57.2,29.1,57.2,29.1,57.3,29.1L57.3,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M51.7,27.8L51.7,27.8C51.7,27.8,51.7,27.8,51.7,27.8c0.2-1.1,0.1-2-0.4-2.6c-0.3-0.4-0.8-0.7-1.1-0.9 c-0.3-0.2-0.6-0.3-0.8-0.7c-0.3-0.7,0.2-1.8,1.6-3.2c0,0,0,0,0,0c0,0,0,0,0,0c-1.4,1.5-1.9,2.6-1.5,3.3c0.2,0.3,0.5,0.5,0.8,0.7 c0.4,0.2,0.8,0.4,1.1,0.9C51.7,25.9,51.8,26.7,51.7,27.8C51.6,27.8,51.7,27.8,51.7,27.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M52.4,18.4L52.4,18.4C52.4,18.4,52.5,18.4,52.4,18.4c0.1-0.7-0.5-0.9-1.2-1c-0.4-0.1-0.8-0.2-1.1-0.5 c-0.2-0.2-0.3-0.4-0.3-0.5c0-0.3,0.4-0.5,0.4-0.5l0,0l0,0c0,0-0.4,0.2-0.5,0.5c0,0.2,0.1,0.4,0.3,0.6c0.3,0.2,0.7,0.4,1.2,0.5 C51.9,17.6,52.5,17.7,52.4,18.4L52.4,18.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step2.400c08ef06ca57c10b3bdfc26dbf3660.svg";
export { ForwardRef as ReactComponent };